import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = ["for"]
const _hoisted_5 = ["value", "id", "name"]
const _hoisted_6 = {
  key: 0,
  class: "fa-solid fa-check fa-xl text-secondary"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioInput',
  props: {
    model: { default: () => ({}) },
    label: { default: "" },
    options: { default: () => [] },
    required: { type: Boolean, default: false },
    name: { default: "" }
  },
  emits: ["onChange"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const onChange = (event: Event) => {
  emit("onChange", (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'option_' + index,
        class: _normalizeClass(["d-flex align-items-center", { 'border-bottom': _ctx.options.length > index + 1 }])
      }, [
        _createElementVNode("label", {
          for: _ctx.name + '_' + index,
          class: "text-paragraph mb-0 flex-fill cursor-pointer py-3"
        }, _toDisplayString(item.name || item.title), 9, _hoisted_4),
        _withDirectives(_createElementVNode("input", {
          hidden: "",
          type: "radio",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.$model) = $event)),
          value: item.id,
          id: _ctx.name + '_' + index,
          name: _ctx.name,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (onChange($event)))
        }, null, 40, _hoisted_5), [
          [_vModelRadio, _ctx.model.$model]
        ]),
        (_ctx.model.$model == item.id)
          ? (_openBlock(), _createElementBlock("i", _hoisted_6))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})